<template>
    <div>
        <div v-if="options.length" class="availability-price-selector" role="group" aria-label="Price type">
            <button
                v-for="option in options"
                :key="option.value"
                type="button"
                class="availability-price-selector__option"
                :class="{'availability-price-selector__option--active': selectedPriceType === option.value}"
                :aria-pressed="selectedPriceType === option.value"
                @click="selectedPriceType = option.value"
            >
                {{ option.label }}
            </button>
        </div>
        <slot :price-type="selectedPriceType"></slot>
    </div>
</template>

<script>
export default {
    props: {
        availablePriceTypes: {
            type: Array,
            default: function () {
                return [];
            },
        },
    },
    data: function () {
        return {
            selectedPriceType: this.$root.availabilityPriceType || 'catered',
            priceTypes: [
                {value: 'catered', label: 'Catered'},
                {value: 'self_catered', label: 'Self-Catered'},
                {value: 'bed_and_breakfast', label: 'Bed & Breakfast'},
            ],
        };
    },
    computed: {
        options: function () {
            return this.priceTypes.filter((priceType) => this.availablePriceTypes.includes(priceType.value));
        },
    },
    watch: {
        selectedPriceType: {
            immediate: true,
            handler: function (priceType) {
                this.$root.availabilityPriceType = priceType;
            },
        },
        options: {
            immediate: true,
            handler: function (options) {
                if (this.$root.availabilityPriceType && options.some((option) => option.value === this.$root.availabilityPriceType)) {
                    this.selectedPriceType = this.$root.availabilityPriceType;

                    return;
                }

                if (options.length && !options.some((option) => option.value === this.selectedPriceType)) {
                    this.selectedPriceType = options[0].value;
                }
            },
        },
    },
};
</script>

<style lang="less" scoped>
.availability-price-selector {
    margin-bottom: 15px;
}

.availability-price-selector__option {
    background: #fff;
    border: 1px solid #504f4d;
    color: #504f4d;
    font-family: "Gotham A", "Gotham B", sans-serif;
    font-size: 11px;
    margin-right: 6px;
    padding: 8px 10px;
    text-transform: uppercase;
}

.availability-price-selector__option--active {
    background: #504f4d;
    color: #fff;
}
</style>
